import { Link as RouterLink, useMatch } from "react-router"

import Stack from "@mui/material/Stack"
import Chip from "@mui/material/Chip"

export const years = [2019, 2020, 2021, 2025]

export default function Years(props) {
  const currentYear = useMatch("/past-speakers/:year")?.params?.year

  return (
    <Stack direction="row" spacing={1} {...props}>
      {years.map((year, index) => (
        <Chip
          aria-label={`Spakers of year ${year}`}
          clickable
          component={RouterLink}
          variant={currentYear === String(year) ? "filled" : "outlined"}
          key={index}
          to={`/past-speakers/${year}`}
          label={year}
          sx={{ fontSize: 15, p: 1, width: "max-content" }}
        />
      ))}
    </Stack>
  )
}
